import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-approvalprimaryuser',
  templateUrl: './approvalprimaryuser.component.html',
  styleUrls: ['./approvalprimaryuser.component.css']
})
export class ApprovalprimaryuserComponent implements OnInit {
  show:boolean=false

  constructor() { }
  approval(){
    this.show=true

  }
  
  reject(){
      this.show=false

    
}
  ngOnInit(): void {
  }

}
